import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import sort from '@alpinejs/sort';
import focus from '@alpinejs/focus';
import { play } from './helpers';
import { BrowserDetector } from './compatibility-detection'

export function registerApplicationDirectives(){
    document.addEventListener('alpine:init', () => {
        Alpine.plugin(sort);
        Alpine.plugin(focus);

        Alpine.magic('currentDevice', () => {
            const { browser, os } = BrowserDetector.parsedResult;

            const userAgent = navigator.userAgent;
            const isTouchDevice = 'ontouchend' in document;

            // Check for iPad with Chrome or Safari
            if(/iPad|Macintosh/.test(userAgent) && isTouchDevice && ['Safari', 'Chrome'].some(b => browser.name.includes(b))){
                return { device: 'ipad', browser, os };
            }

            // Check for iOS with Safari 11.3+
            // https://firt.dev/notes/pwa-ios/#high-level-pwa-support PWA is supported only from safari 11.3
            if(os.name === 'iOS' && browser.name === 'Safari' && parseFloat(browser.version) >= 11.3){
                return { device: 'iphone', browser, os };
            }

            // Check for Chrome on iOS or Android
            if(['iOS', 'Android'].some(b => os.name.includes(b)) && browser.name === 'Chrome'){
                const device = os.name === 'iOS' ? 'iphone' : 'android';
                return { device, browser, os };
            }

            return { device: false, browser, os };
        });

        Alpine.magic(
            'tooltip', (el => {
                return (message, props = {}) => {
                    const timeout = props.timeout ?? 2000;

                    if ('timeout' in props) {
                        delete props.timeout;
                    }

                    const instance = tippy(el, { content: message, theme: 'palisade', allowHTML: true, ...props });

                    if(!props.interactive){
                        setTimeout(() => instance.destroy(), timeout)
                    }
                }
            })
        );

        Alpine.directive('title',(el, { expression }, { evaluateLater, effect }) => {
            const evaluate = evaluateLater(expression)

            effect(
                () => evaluate(
                    text => {
                        el.textContent = text
                            .trim()
                            .replace(/[\s~`!@#$%^&*(){}\[\];:"'<,.>?\/\\|_+=-]/g, ' ')
                            ?.toLowerCase()
                            ?.split(' ')
                            ?.map(word => word.replace(word[0], word[0]?.toUpperCase()))
                            ?.join(' ')
                            ?.trim() || text;
                    }
                )
            );
        });

        Alpine.directive('play', (el, { expression }) => el.addEventListener('click', () => play(expression)));
        Alpine.magic('play', () => (expression) => play(expression));

        Alpine.store('zoom', {
            scale: 'none',

            style() {
                return {
                    scale: this.scale,
                    transform: this.scale != 'none'
                        ? `translate(${-50 / this.scale}%, ${-50 / this.scale}%)`
                        : 'translate(-50%, -50%)'
                };
            }
        });
    });
};

export function registerPalisadeDirectives() {
    document.addEventListener('alpine:init', () => {
        Alpine.plugin(focus);
        Alpine.magic(
            'tooltip', (el => {
                return (message, props = {}) => {
                    const timeout = props.timeout ?? 2000;

                    if ('timeout' in props) {
                        delete props.timeout;
                    }

                    const instance = tippy(el, { content: message, theme: 'palisade', allowHTML: true, ...props });

                    setTimeout(() => instance.destroy(), timeout)
                }
            })
        );
    });
}
